module.exports = __webpack_public_path__ + "static/media/ic_invest_explore_mf.cb1f6571.svg";